import { useState } from 'react'
import { Form } from 'react-final-form'
import { defineMessages, FormattedMessage } from 'react-intl'
import { FormInput } from '../forms/final-form-fields'
import './styles/coupon-form.scss'
import API from 'api'

const messages = defineMessages({
  gift: {
    id: 'gift_voucher',
    defaultMessage: 'Gift voucher / discount code',
  },
})
export default function CouponForm({ onSuccess }) {
  const [isVisible, setVisibility] = useState(false)
  const showForm = () => setVisibility(true)
  const onSubmit = (values, form) =>
    API('coupons/validate/')
      .post(values)
      .then((data) => {
        setVisibility(false)
        onSuccess(data)
        form.reset()
      })
  return (
    <Form
      onSubmit={onSubmit}
      subscription={{
        value: true,
      }}
      render={({ handleSubmit, form }) => {
        return (
          <div className='discount-section'>
            <span className='link-color add-coupon' onClick={showForm}>
              <FormattedMessage
                id='aaply_voucher'
                defaultMessage='Apply a voucher / coupon code'
              />
            </span>
            {isVisible && (
              <form onSubmit={(e) => handleSubmit(e, form)}>
                <div className='coupoun-input'>
                  <FormInput name='code' placeholder={messages.gift} />
                  <button className='grey-btn'>
                    <FormattedMessage id='apply' defaultMessage='Apply' />
                  </button>
                </div>
              </form>
            )}
          </div>
        )
      }}
    />
  )
}
